import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navigation: React.FC = () => {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const isActive = (path: string) => location.pathname === path;

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className="navigation">
      <button
        className="navigation-hamburger"
        onClick={toggleMenu}
        aria-label="Toggle navigation menu"
      >
        <span className="hamburger-label">{isMenuOpen ? 'Close menu' : 'Open menu'}</span>
      </button>

      <div className={`navigation-overlay ${isMenuOpen ? 'navigation-overlay--open' : ''}`} onClick={closeMenu}></div>

      <ul className={`navigation-list ${isMenuOpen ? 'navigation-list--open' : ''}`}>
        <li>
          <Link
            to="/"
            className={`navigation-link ${isActive('/') ? 'navigation-link--active' : ''}`}
            onClick={closeMenu}
          >
            Home
          </Link>
        </li>
        <li>
          <Link
            to="/faqs"
            className={`navigation-link ${isActive('/faqs') ? 'navigation-link--active' : ''}`}
            onClick={closeMenu}
          >
            FAQs
          </Link>
        </li>
        <li>
          <Link
            to="/weekend-schedule"
            className={`navigation-link ${isActive('/weekend-schedule') ? 'navigation-link--active' : ''}`}
            onClick={closeMenu}
          >
            Weekend schedule
          </Link>
        </li>
        <li>
          <Link
            to="/travel-and-accommodation"
            className={`navigation-link ${isActive('/travel-and-accommodation') ? 'navigation-link--active' : ''}`}
            onClick={closeMenu}
          >
            Travel & Accommodation
          </Link>
        </li>
        <li>
          <Link
            to="/wedding-party"
            className={`navigation-link ${isActive('/wedding-party') ? 'navigation-link--active' : ''}`}
            onClick={closeMenu}
          >
            The wedding party
          </Link>
        </li>
        <li>
          <Link
            to="/gifts"
            className={`navigation-link ${isActive('/gifts') ? 'navigation-link--active' : ''}`}
            onClick={closeMenu}
          >
            Gifts
          </Link>
        </li>
      </ul>
    </nav>
  );
};

export default Navigation;
